var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ItemList',{attrs:{"events":_vm.events,"category":_vm.category}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }